import Vue from 'vue'
import Router from 'vue-router'

// in development-env not use lazy-loading, because lazy-loading too many pages will cause webpack hot update too slow. so only in production use lazy-loading;
// detail: https://panjiachen.github.io/vue-element-admin-site/#/lazy-loading

Vue.use(Router)

/* 中文版 */
import common from '../views/common/index'
import index from '../views/index/index'
import about from '../views/about/index'
import aboutDetails from '../views/about-details/index'
import qualification from '../views/qualification/index'
import cases from '../views/cases/index'
import caseDetails from '../views/case-details/index'
import discloseInfo from '../views/disclose-info/index'
import products from '../views/products/index'
import news from '../views/news/index'
import newsCenter from '../views/news-center/index'
import newsDetails from '../views/news-details/index'
import contact from '../views/contact/index'
import productsList from '../views/products-list/index'
import productsDetails from '../views/products-details/index'
/* 英文版 */
import en_common from '../en/common/index'
import en_index from '../en/index/index'
import en_about from '../en/about/index'
import en_aboutDetails from '../en/about-details/index'
import en_qualification from '../en/qualification/index'
import en_cases from '../en/cases/index'
import en_caseDetails from '../en/case-details/index'
import en_discloseInfo from '../en/disclose-info/index'
import en_products from '../en/products/index'
import en_news from '../en/news/index'
import en_newsCenter from '../en/news-center/index'
import en_newsDetails from '../en/news-details/index'
import en_contact from '../en/contact/index'
import en_productsList from '../en/products-list/index'
import en_productsDetails from '../en/products-details/index'

/**
* hidden: true                   if `hidden:true` will not show in the sidebar(default is false)
* alwaysShow: true               if set true, will always show the root menu, whatever its child routes length
*                                if not set alwaysShow, only more than one route under the children
*                                it will becomes nested mode, otherwise not show the root menu
* redirect: noredirect           if `redirect:noredirect` will no redirct in the breadcrumb
* name:'router-name'             the name is used by <keep-alive> (must set!!!)
* meta : {
    title: 'title'               the name show in submenu and breadcrumb (recommend set)
    icon: 'svg-name'             the icon show in the sidebar,
  }
**/
export const constantRouterMap = [
  //{ path: '/login', component: () => import('@/views/login/index'), hidden: true },
  { path: '/404', component: () => import('@/views/404'), hidden: true },
  {
    path: '/',
    redirect: '/index',

  },
  {
    path: '/',
    component: common,
    meta: {
      title: '冠龙'
    },
    children: [ // 此级别组件将显示在header下面和侧边栏右边的区域
      {
        path: '/index',
        component: index,
        meta: {
          title: '首页',
          keepAlive: true
        }
      },
      {
        path: '/about',
        component: about,
        meta: {
          title: '关于冠龙'
        },
        children: [
          {
            path: '/about',
            component: aboutDetails,
            meta: {
              title: '关于冠龙',
              keepAlive: true
            }
          }, {
            path: '/qualification',
            component: qualification,
            meta: {
              title: '公司资质',
              keepAlive: true
            }
          }, {
            path: '/cases',
            component: cases,
            meta: {
              title: '工程案例',
              keepAlive: true
            }
          }, {
            path: '/case-details/:id',
            component: caseDetails,
            meta: {
              title: '新闻详情',
              keepAlive: true
            }
          }, {
            path: '/disclose-info',
            component: discloseInfo,
            meta: {
              title: '信息公开',
              keepAlive: true
            }
          }
        ]
      },
      {
        path: '/products',
        component: products,
        meta: {
          title: '产品系列'
        },
        children: [
          {
            path: '/products',
            component: productsList,
            meta: {
              title: '产品系列',
              keepAlive: true
            }
          }, {
            path: '/products-details/:id',
            component: productsDetails,
            meta: {
              title: '产品系列详情',
              keepAlive: true
            }
          }
        ]
      },
      {
        path: '/news',
        component: news,
        meta: {
          title: '新闻中心'
        },
        children: [
          {
            path: '/news',
            component: newsCenter,
            meta: {
              title: '新闻中心',
              keepAlive: true
            }
          }, {
            path: '/news-details/:id',
            component: newsDetails,
            meta: {
              title: '新闻详情',
              keepAlive: true
            }
          }
        ]
      },
      {
        path: '/contact',
        component: contact,
        meta: {
          title: '联系我们'
        }
      },
      // {
      //   path: '/about',
      //   component: about,
      //   meta: {
      //     title: '投资者关系'
      //   }
      // },
    ]
  },
  {
    path: '/en',
    component: en_common,
    meta: {
      title: 'guanlong'
    },
    children: [ // 此级别组件将显示在header下面和侧边栏右边的区域
      {
        path: '/en_index',
        component: en_index,
        meta: {
          title: 'guanlong',
          keepAlive: true
        }
      },
      {
        path: '/en_about',
        component: en_about,
        meta: {
          title: '关于冠龙'
        },
        children: [
          {
            path: '/en_about',
            component: en_aboutDetails,
            meta: {
              title: '关于冠龙',
              keepAlive: true
            }
          }, {
            path: '/en_qualification',
            component: en_qualification,
            meta: {
              title: '公司资质',
              keepAlive: true
            }
          }, {
            path: '/en_cases',
            component: en_cases,
            meta: {
              title: '工程案例',
              keepAlive: true
            }
          }, {
            path: '/en_case-details/:id',
            component: en_caseDetails,
            meta: {
              title: '新闻详情',
              keepAlive: true
            }
          }, {
            path: '/en_disclose-info',
            component: en_discloseInfo,
            meta: {
              title: '信息公开',
              keepAlive: true
            }
          }
        ]
      },
      {
        path: '/en_products',
        component: en_products,
        meta: {
          title: '产品系列'
        },
        children: [
          {
            path: '/en_products',
            component: en_productsList,
            meta: {
              title: '产品系列',
              keepAlive: true
            }
          }, {
            path: '/en_products-details/:id',
            component: en_productsDetails,
            meta: {
              title: '产品系列详情',
              keepAlive: true
            }
          }
        ]
      },
      {
        path: '/en_news',
        component: en_news,
        meta: {
          title: '新闻中心'
        },
        children: [
          {
            path: '/en_news',
            component: en_newsCenter,
            meta: {
              title: '新闻中心',
              keepAlive: true
            }
          }, {
            path: '/en_news-details/:id',
            component: en_newsDetails,
            meta: {
              title: '新闻详情',
              keepAlive: true
            }
          }
        ]
      },
      {
        path: '/en_contact',
        component: en_contact,
        meta: {
          title: '联系我们'
        }
      },
    ]
  },
  { path: '*', redirect: '/404', hidden: true }
]

export default new Router({
  // mode: 'history', //后端支持可开
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  },

  routes: constantRouterMap
})




// WEBPACK FOOTER //
// ./src/router/index.js